import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './checkList.types';

export const checkListSelectors = {
  ...generateResourceSelectors<types.ICheckList>((state) => state.resource.checkList),
};
